import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex)

export const idTypes = {
  namespaced: true,
  state: () => ({
    idTypes: null,
  }),
  mutations: {
    SET_ID_TYPES(state, data) {
      state.idTypes = data;
    },
  },
  actions: {
    fetchIDTypes({ commit }) {
      const url = `enums/type-of-ids`;

      return this.$axios
        .get(url)
        .then((response) => {
          commit("SET_ID_TYPES", response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching ID types: ", error);
        });
    },
  },
};
